// frontend/src/api/roles.js (or constants/roles.js)

export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  AI_ADMIN: 'ai_admin',
  PLANT_MANAGER: 'plant_manager',
  MAINTENANCE_TECHNICIAN: 'maintenance_technician',
  MACHINE_OPERATOR: 'machine_operator',
  QUALITY_OFFICER: 'quality_officer'
};

export const PERMISSIONS = {
  // Who can schedule and re-assign tickets
  MANAGE_MAINTENANCE: [
    ROLES.SUPER_ADMIN, 
    ROLES.PLANT_MANAGER,
    ROLES.QUALITY_OFFICER
  ],

  MANAGE_MACHINES: [
    ROLES.SUPER_ADMIN, 
    ROLES.PLANT_MANAGER
  ],
  
  // Who can actually start and file a log
  EXECUTE_MAINTENANCE: [
    ROLES.SUPER_ADMIN, 
    ROLES.MAINTENANCE_TECHNICIAN, 
    ROLES.MACHINE_OPERATOR
  ],

  // Who can approve SOP templates
  APPROVE_SOP: [
    ROLES.SUPER_ADMIN, 
    ROLES.PLANT_MANAGER, 
    ROLES.QUALITY_OFFICER
  ],

  // Who can manage AI training and documents
  MANAGE_KNOWLEDGE: [
    ROLES.SUPER_ADMIN, 
    ROLES.AI_ADMIN
  ]
};